// constants.js
export const ROUTER_PUSH = 'ROUTER_PUSH'
export const ROUTER_REPLACE = 'ROUTER_REPLACE'
export const ROUTER_GO = 'ROUTER_GO'
export const ROUTER_BACK = 'ROUTER_BACK'
export const ROUTER_FORWARD = 'ROUTER_FORWARD'
export const ROUTER_LOCATION_CHANGE = 'ROUTER_LOCATION_CHANGE'
